import { FC } from "react";
import { useEffect } from "react";

import Pause from "../../../assets/icon/Pause";
import PauseMain from "../../../assets/icon/PauseMain";
import Play from "../../../assets/icon/Play";
import PlayMain from "../../../assets/icon/PlayMain";
import Wave from "../../../assets/icon/Wave";

interface Props {
  // type: "play" | "pause" | "wave";
  width?: string;
  height?: string;
  type: string;
  radio?: boolean;
  playForTrack?: boolean;
  main?: boolean;
  disabled?: boolean;
  onClick?: () => void;
  onTouchEnd?: (e: React.TouchEvent) => void;
}

const ButtonPlayer: FC<Props> = ({
  width,
  height,
  type,
  main,
  disabled,
  radio,
  playForTrack,
  onClick,
  onTouchEnd,
}) => {
  return (
    <button
      onClick={onClick}
      onTouchEnd={onTouchEnd}
      disabled={disabled}
      className={
        "text-white align-middle focus:outline-none text-sm text-center inline-flex items-center transition-colors duration-200"
      }
      style={{
        WebkitTapHighlightColor: "transparent",
      }}
    >
      {type === "play" && main && <PlayMain width={width} height={height} />}
      {type === "pause" && main && <PauseMain width={width} height={height} />}

      {type === "play" && !main && <Play width={width} height={height} />}
      {type === "pause" && !main && <Pause width={width} height={height} />}
      {type === "wave" && !main && playForTrack && (
        <Wave width={width} height={height} />
      )}
    </button>
  );
};

export default ButtonPlayer;
